export default "__VITE_ASSET__489c8b88__"